import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Tooltip
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import DatePicker from "react-date-picker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import loader from "../../../style/loader/loader.scss";
import { removeChildContract } from "../../../redux/actions/contractActions";
import Attributes from "./Attributes";

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {};

let offerTitle = [],
  french_offerTitle = [],
  skuCode = [],
  numberOfWinners = [],
  bidIncrements = [],
  offerPrice = [],
  remittance = [],
  remittanceVal =[],
  buyNowOption = [],
  freeShipping = [],
  shippingAmount = [],
  shippingAmountMerchant = [],
  shippingAmountAdmin = [],
  offerPriceVal = [],
  updatedDate = [];


class AdditionalPrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      affiliateOption: this.props.affiliateOption,
      indexKey: this.props.indexKey,
      attributeStatus: false,
      attributes: "",
      priceData: this.props.priceData ? this.props.priceData : "",
      datedisable: false,
      incRed: 0,
      monthdisable: false,
      multi_lang: 'no',
      offerPriceVal: "",
      remittanceVal: "",
      hideMsg: false,
    };
    freeShipping[this.props.indexKey] = "0";
  }

  AttributeStatus = () => {
    this.setState({ attributeStatus: true });
  };

  componentDidMount() {
     this.setState({ remittanceVal: this.props.priceData.remittance, offerPriceVal: this.props.priceData.offerPrice, incRed: this.props.priceData.freeShipping });
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.multi_lang){
        this.setState({
          multi_lang: siteData.multi_lang
        });
      }
    }
    if (this.state.priceData == "") {
      offerTitle[this.state.indexKey] = "";
      french_offerTitle[this.state.indexKey] = "";
      skuCode[this.state.indexKey] = "";
      numberOfWinners[this.state.indexKey] = "";
      bidIncrements[this.state.indexKey] = "";
      offerPrice[this.state.indexKey] = "";
      remittance[this.state.indexKey] = "";
      buyNowOption[this.state.indexKey] = "";
      freeShipping[this.state.indexKey] = "";
      shippingAmount[this.state.indexKey] = "";
      shippingAmountMerchant[this.state.indexKey] = "";
      shippingAmountAdmin[this.state.indexKey] = "";
    }
    
  }

  componentWillReceiveProps(nextProps) {

  }

  removePriceDetail = e => {
    let getContractID = e.target.attributes.getNamedItem("data-key").value;
    if (getContractID != '') {
      this.props.removeChildContract(getContractID);
      this.props.removePriceDetail(this.state.indexKey, getContractID);
    }else{
      this.props.removePriceDetail(this.state.indexKey, getContractID);
    }
  };

  handleOfferChange = e => {
    offerTitle[this.state.indexKey] = e.target.value;
    this.props.handleOfferChange(e.target.value, this.state.indexKey);
  };

  handleFrenchOfferChange = e => {
    french_offerTitle[this.state.indexKey] = e.target.value;
    this.props.handleFrenchOfferChange(e.target.value, this.state.indexKey);
  };

  handleskuCodeChange = e => {
    skuCode[this.state.indexKey] = e.target.value;
    this.props.handleskuCodeChange(e.target.value, this.state.indexKey);
  };

  handlenumberOfWinnersChange = e => {
    numberOfWinners[this.state.indexKey] = e.target.value;
    this.props.handlenumberOfWinnersChange(e.target.value, this.state.indexKey);
  };

  handlebidIncrementsChange = e => {
    bidIncrements[this.state.indexKey] = e.target.value;
    this.props.handlebidIncrementsChange(e.target.value, this.state.indexKey);
  };

  handleofferPriceChange = e => {
    offerPrice[this.state.indexKey] = e.target.value;
    this.props.handleofferPriceChange(e.target.value, this.state.indexKey);
    this.setState({ offerPriceVal: offerPrice[this.state.indexKey] });
  };

  handleremittanceChange = e => {
    remittance[this.state.indexKey] = e.target.value;    
    this.props.handleremittanceChange(e.target.value, this.state.indexKey);
    this.setState({ remittanceVal: remittance[this.state.indexKey] });
  };

  handlebuyNowOptionChange = e => {
    buyNowOption[this.state.indexKey] = e.target.value;
    this.props.handlebuyNowOptionChange(
      e.target.value,
      this.state.indexKey
    );
  };

  handlefreeShippingChange = e => {
    freeShipping[this.state.indexKey] = e.target.value;
    this.props.handlefreeShippingChange(
      e.target.value,
      this.state.indexKey
    );
    this.setState({incRed: e.target.value});
  };

  handleshippingAmountChange = e => {
    shippingAmount[this.state.indexKey] = e.target.value;
    this.props.handleshippingAmountChange(
      e.target.value,
      this.state.indexKey
    );
  };

  handleshippingAmountMerchantChange = e => {
    shippingAmountMerchant[this.state.indexKey] = e.target.value;
    this.props.handleshippingAmountMerchantChange(
      e.target.value,
      this.state.indexKey
    );
    this.setState({sMerchant : e.target.value});
  };

  handleshippingAmountAdminChange = e => {
    shippingAmountAdmin[this.state.indexKey] = e.target.value;
    this.props.handleshippingAmountAdminChange(
      e.target.value,
      this.state.indexKey
    );
    this.setState({sAdmin : e.target.value});
  };

  attributeData = (data, idx) => {  
    if (this.props.priceData) {
      this.props.handleUpdate("attributes", data, this.state.indexKey);
    } else {
      this.props.attributeData(data, this.state.indexKey);
    }
  };

  matrixData = (data, idx) => {
    if (this.props.priceData) {
      this.props.handleUpdate("metrix", data, this.state.indexKey);
    } else {
      this.props.matrixData(data, this.state.indexKey);
    }
  };

  handleShippingPercent = e => {
    let shippingAmountAdminConst,
    shippingAmountMerchantConst,
    sumOfPercent = 0.0;
    if (this.state.sAdmin || this.state.sMerchant) {
      shippingAmountAdminConst =
      this.state.sAdmin !== 0 &&
      typeof this.state.sMerchant !== "NaN"
      ? Number.parseFloat(this.state.sAdmin)
      : 0;
      shippingAmountMerchantConst =
      this.state.sMerchant !== 0 &&
      typeof this.state.sMerchant !== "NaN"
      ? Number.parseFloat(this.state.sMerchant)
      : 0;

      sumOfPercent = shippingAmountAdminConst + shippingAmountMerchantConst;
      if (sumOfPercent !== 100) {
        this.setState({
          shippingAmountAdminError: "red",
          shippingAmountMerchantError: "red"
        });
        if (e.target.name === "shippingAmountMerchant") {
          this.setState({
            shippingAmountAdminTooltipError:
            "Sum of Merchant Shipping and Admin Shipping should be 100%"
          });
        } else if (e.target.name === "shippingAmountAdmin") {
          this.setState({
            shippingAmountAdminTooltipError:
            "Sum of Merchant Shipping and Admin Shipping should be 100%"
          });
        }
      }else if (sumOfPercent === 100) {
        this.setState({
          shippingAmountMerchantTooltipError: "",
          shippingAmountAdminTooltipError: "",
          shippingAmountMerchantError: "",
          shippingAmountAdminError: ""
        });
      }
    }
  };

  handleUpdate = e => {
    
    this.props.handleUpdate(e.target.name, e.target.value, this.state.indexKey);

    if (e.target.name == "remittance") {
     this.setState({ remittanceVal: e.target.value });
    }
    if (e.target.name == "offerPrice") {
     this.setState({ offerPriceVal: e.target.value });
    }
    if (e.target.name == "freeShipping") {
      this.setState({incRed: e.target.value, freeShipping: e.target.value});  
    }
    if (e.target.name == "shippingAmountMerchant") {
      this.setState({sMerchant : e.target.value}); 
    }
    if (e.target.name == "shippingAmountAdmin") { 
      this.setState({sAdmin : e.target.value}); 
    }    
  };


  render() {
    return (
      <Row key={this.state.indexKey}>
        <div className="col-lg-12 add-sub-admin">
          {/**start contract price information **/}
          <div className="panel">
            <header className="panel-heading">
              Pricing Detail{" "}
              <Button
                bsSize="small"
                bsStyle="danger"
                className="pull-right"
                data-key={
                  this.state.priceData ? this.state.priceData.contractID : ""
                }
                onClick={this.removePriceDetail}
              >
                Remove
              </Button>
            </header>
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formOfferTitle">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Auction Title
                      </ControlLabel>
                      <FormControl
                        type="text"
                        defaultValue={
                          offerTitle[this.state.indexKey]
                            ? offerTitle[this.state.indexKey]
                            : this.props.priceData.offerTitle
                        }
                        placeholder="Auction Title"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleOfferChange
                        }
                        name="offerTitle"
                        style={{ borderColor: this.state.offerTitleError }}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    {(this.state.multi_lang == "yes") &&
                    <FormGroup controlId="french_offerTitle">
                      <ControlLabel>
                        Auction Title (Canadian French)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        defaultValue={
                          french_offerTitle[this.state.indexKey]
                            ? french_offerTitle[this.state.indexKey]
                            : this.props.priceData.french_offerTitle
                        }
                        placeholder="Auction Title"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleFrenchOfferChange
                        }
                        name="french_offerTitle"
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    }
                    
                      <ControlLabel>
                        SKU #
                      </ControlLabel>
                      <FormGroup controlId="formSkuCode">
                        <FormControl
                          type="text"
                          placeholder="SKU Code"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleskuCodeChange
                          }
                          name="skuCode"
                          style={{ borderColor: this.state.skuCodeError }}
                          defaultValue={
                            skuCode[this.state.indexKey]
                              ? skuCode[this.state.indexKey]
                              : this.props.priceData.skuCode
                          }
                        />
                        <FormControl.Feedback />
                      </FormGroup>

                      <ControlLabel>
                        Number of Winners
                        (Optional)
                      </ControlLabel>                      
                      <FormGroup controlId="formNumberOfWinners">
                        <FormControl
                          type="number"
                          placeholder="Number of Winners"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handlenumberOfWinnersChange
                          }
                          name="numberOfWinners"
                          style={{
                            borderColor: this.state.numberOfWinnersError
                          }}
                          defaultValue={
                            numberOfWinners[this.state.indexKey]
                              ? numberOfWinners[this.state.indexKey]
                              : this.props.priceData.numberOfWinners
                          }
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                      
                      <ControlLabel>
                       Buy It Now Option (Optional)
                      </ControlLabel>
                      <FormGroup controlId="formBuyNowOption">
                        <FormControl
                          type="number"
                          placeholder="Bid Increments"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handlebidIncrementsChange
                          }
                          name="buyNowOption"
                          defaultValue={
                            buyNowOption[this.state.indexKey]
                              ? buyNowOption[this.state.indexKey]
                              : this.props.priceData.buyNowOption
                          }
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                  </Col>

                  <Col md={6} xs={12}>

                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Minimum Bid Amount
                    </ControlLabel>
                    <FormGroup controlId="formMinBidAmount">
                      <FormControl
                        type="number"
                        placeholder="Minimum Bid Amount"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handleofferPriceChange
                        }
                        name="offerPrice"
                        style={{ borderColor: this.state.offerPriceError }}
                        defaultValue={
                          offerPrice[this.state.indexKey]
                            ? offerPrice[this.state.indexKey]
                            : this.props.priceData.offerPrice
                        }
                      />
                      <FormControl.Feedback />
                    </FormGroup>

                    <ControlLabel>
                       Bid Increments (Optional)
                    </ControlLabel>
                    <FormGroup controlId="formBidIncrements">
                      <FormControl
                        type="number"
                        placeholder="Bid Increments"
                        onChange={
                          this.props.priceData
                            ? this.handleUpdate
                            : this.handlebidIncrementsChange
                        }
                        name="bidIncrements"
                        style={{ borderColor: this.state.bidIncrementsError }}
                        defaultValue={
                          bidIncrements[this.state.indexKey]
                            ? bidIncrements[this.state.indexKey]
                            : this.props.priceData.bidIncrements
                        }
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                    <FormGroup controlId="formShippingAmount">
                        <ControlLabel>
                          Set Shipping Amount?
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          name="freeShipping"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handlefreeShippingChange
                          }
                          defaultValue={
                            this.props.priceData.freeShipping
                              ? this.props.priceData.freeShipping
                              : freeShipping[this.state.indexKey]
                          }
                        >
                          <option value="0">No</option>
                          <option value="1">Yes</option>
                        </FormControl>
                    </FormGroup>
                    {(this.state.incRed == '1') &&
                    <FormGroup>
                      <ControlLabel>Shipping Amount</ControlLabel>
                      <FormControl
                        type="number"
                        defaultValue={this.props.priceData ? this.props.priceData.shippingAmount : shippingAmount[this.state.indexKey]}
                        placeholder="Shipping Amount"
                        onChange={this.props.priceData
                              ? this.handleUpdate
                              : this.handleshippingAmountChange
                            }
                        name="shippingAmount"
                      />
                    </FormGroup>
                    }
                    {(this.state.incRed == '1') &&
                    <FormGroup>
                      <ControlLabel>Merchant Shipping %</ControlLabel>
                      <FormControl
                        type="number"
                        defaultValue={this.props.priceData ? this.props.priceData.shippingAmountMerchant : shippingAmountMerchant[this.state.indexKey]}
                        placeholder="Merchant Shipping %"
                        onChange={this.props.priceData
                              ? this.handleUpdate
                              : this.handleshippingAmountMerchantChange
                            }
                        name="shippingAmountMerchant"
                        onBlur={this.handleShippingPercent}
                        style={{borderColor: this.state.shippingAmountMerchantError}}
                      />
                    </FormGroup>
                    }
                    {(this.state.incRed == '1') &&
                    <FormGroup>
                      <ControlLabel>Admin Shipping %</ControlLabel>
                      <FormControl
                        type="number"
                        defaultValue={this.props.priceData ? this.props.priceData.shippingAmountAdmin : shippingAmountAdmin[this.state.indexKey]}
                        placeholder="Admin Shipping %"
                        onChange={this.props.priceData
                              ? this.handleUpdate
                              : this.handleshippingAmountAdminChange
                            }
                        name="shippingAmountAdmin"
                        onBlur={this.handleShippingPercent}
                        style={{borderColor: this.state.shippingAmountAdminError}}
                      />
                      {this.state.shippingAmountAdminTooltipError && (
                        <Tooltip
                        placement="bottom"
                        className="in"
                        id="tooltip-top"
                        style={{ marginLeft: "386px", marginTop: "36px" }}
                        >
                        {this.state.shippingAmountAdminTooltipError}
                        </Tooltip>
                        )}
                    </FormGroup>
                    }

                    {(this.state.affiliateOption == false && this.state.offerPriceVal !='') ? 
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Remittance Per
                        Unit (what we pay the merchant) 
                        ({(this.state.offerPriceVal > 0) ? parseFloat(((this.state.offerPriceVal -  (this.state.remittanceVal ? this.state.remittanceVal : 0.00))/ this.state.offerPriceVal)*100).toFixed(2) : 0.00} % Margin)
                      </ControlLabel>
                     : this.state.affiliateOption == false ? 
                    <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Remittance Per
                        Unit (what we pay the merchant) (0.00 % Margin)
                      </ControlLabel>
                    : null
                    }
                    {this.state.affiliateOption == false ? (
                      <FormGroup controlId="formRemittance">
                        <FormControl
                          type="number"
                          placeholder="Remittance Per Unit"
                          onChange={
                            this.props.priceData
                              ? this.handleUpdate
                              : this.handleremittanceChange
                          }
                          name="remittance"
                          style={{ borderColor: this.state.remittanceError }}
                          defaultValue={
                            remittance[this.state.indexKey]
                              ? remittance[this.state.indexKey]
                              : this.props.priceData.remittance
                          }
                        />
                        <FormControl.Feedback />
                      </FormGroup>
                    ) : null}
                    
                  </Col>
                </Row>
                    <Row>
                      <Col md={12} xs={12}>
                        <Attributes 
                          indexKey={this.state.indexKey}
                          attributeData={this.attributeData} 
                          matrixData={this.matrixData}
                          postAttributes={(this.props.priceData && this.props.priceData.attribute) ? this.props.priceData.attribute : []}
                          postMatrix={(this.props.priceData && this.props.priceData.metrix) ? this.props.priceData.metrix : []}
                          key={Math.random()}
                        />
                      </Col>
                    </Row>
               
              </div>
            </div>
          </div>
          {/**end contract price information **/}
        </div>
      </Row>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    deletedContract: state.contractReducer.deletedContract,
    error: state.contractReducer.error
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, { removeChildContract })
)(AdditionalPrice);



// WEBPACK FOOTER //
// ./src/app/views/admin/auction/AdditionalPrice.js